import { render, staticRenderFns } from "./RejectionPopup.vue?vue&type=template&id=780038f0"
import script from "./RejectionPopup.vue?vue&type=script&lang=js"
export * from "./RejectionPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports